import { Skeleton } from '@radix-ui/themes';

import { ContentLayout } from '../ContentLayout/ContentLayout';

export function TablePageSkeleton() {
  return (
    <ContentLayout
      sideContent={
        <div className='p-fly-4'>
          {' '}
          <Skeleton className='min-h-80' />
        </div>
      }
    >
      <div className='flex flex-col pt-fly-4'>
        <Skeleton className='h-8 mb-[28px]' />
        <Skeleton className='h-[400px]' />
      </div>
    </ContentLayout>
  );
}
